<template>
  <section class="home">
    <article class="article">
      <div class="home-body">
          <h2 class="article-title">虚拟化启动应用 双开永久免费</h2>
          <p class="article-title-desc">为您的多面生活助力</p>
          <p class="article-title-p">无论是游戏还是社交软件，多个账号同时在线，实现之前看似不可能的任务，</p>
          <p class="article-title-p">此外您还可以DIY多开程序的图标和名字，个性十足！</p>
          <div class="article-img">
              <img src="../assets/home-bg.png" />
              <img src="../assets/home-bg1.png" />
          </div>
      </div>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      
    }
  },
  methods: {
    toLogin() {
      this.$router.push('./login')
    }
  }
}
</script>
<style scoped>
.home-body{
  text-align: center;
  color: #ffffff;
  padding: 50px 0 150px 0;
  background: linear-gradient(0deg, #74E3D7, #33C4E3);
}
.article-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 54px;
  margin: 70px 0 100px 0;
}
.article-title-desc{
  font-size: 36px;
  margin-bottom: 44px;
}
.article-title-p{
  font-size: 24px;
  margin-bottom: 20px;
}
.article-img img{
  margin-top: 50px;
  width: 440px;
  height: 570px;
  border-radius: 40px;
}
.article-img img:first-child{
  margin-right: 20px;
}
.article-img img:last-child{
  margin-left: 20px;
}
</style>